// components/router/RequireStaff.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../../contexts/ContextProvider";
import Loader from "../dataDisplay/Loader";

/**
 * Garde des écrans Peace&Work.
 *
 * Un hôtelier qui atterrit ici est renvoyé vers son espace : ses appels d'API
 * seraient de toute façon refusés, autant lui montrer l'écran qui le concerne
 * plutôt qu'une page en erreur.
 *
 * Le super-admin n'est pas concerné : il traverse dans les deux sens.
 */
export default function RequireStaff() {
    const { token, user, isUserLoading } = useStateContext();

    if (!token) return <Navigate to="/login" replace />;

    // `isUserLoading` ne suffit pas : il vaut `false` avant même que la
    // requête de profil ne parte, et la garde tranchait alors sur un
    // utilisateur vide. Toute sous-route ouverte directement — un lien
    // partagé, un rafraîchissement — rebondissait vers l'accueil, l'adresse
    // demandée perdue en chemin. `user.id === 0` est le marqueur du profil
    // pas encore résolu, comme dans `SmartRedirect`.
    if (isUserLoading || user.id === 0) {
        return <Loader message="chargement" useNeutralLoader={true} />;
    }

    if (user.is_hotelier && !user.is_super_admin) {
        return <Navigate to="/espace" replace />;
    }

    return <Outlet />;
}
